// The inline state pill: HonestState rendered as a pill. One import site for
// the 15 variants so rows, headers and tabs never restyle the state.
import { HonestState, type HonestStateProps } from '../states/HonestState';

export type StatePillProps = Omit<HonestStateProps, 'as' | 'title' | 'detail'>;

export function StatePill(props: StatePillProps) {
  return <HonestState {...props} as="pill" />;
}
